import { render, staticRenderFns } from "./Tenants.vue?vue&type=template&id=0d220fd4&scoped=true"
import script from "./Tenants.vue?vue&type=script&lang=js"
export * from "./Tenants.vue?vue&type=script&lang=js"
import style0 from "./Tenants.vue?vue&type=style&index=0&id=0d220fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d220fd4",
  null
  
)

export default component.exports